import { StatusWidget } from '@pages/dashboard/components/StatusWidget';
import { TotalBalance } from '@pages/dashboard/components/TotalBalance';

import { ApprovalsMessagesWidget } from './components/ApprovalsMessagesWidget';
import { DashboardHeader } from './components/DashboardHeader';
import { RecentTransactionsWidget } from './components/RecentTransactions/RecentTransactionsWidget';

export const DashboardView = () => {
	return (
		<div className="flex gap-space-24 flex-col">
			<DashboardHeader />
			<div className="grid grid-cols-1 min-[1000px]:grid-cols-5 gap-space-24">
				<div className="min-[1000px]:col-span-3 h-full">
					<TotalBalance />
				</div>
				<div className="min-[1000px]:col-span-2 h-full">
					<StatusWidget />
				</div>
			</div>
			<div className="grid grid-cols-1 min-[1000px]:grid-cols-2 gap-space-24">
				<div className="min-[1000px]:col-span-1 h-full">
					<RecentTransactionsWidget />
				</div>
				<div className="min-[1000px]:col-span-1 h-full">
					<ApprovalsMessagesWidget />
				</div>
			</div>
		</div>
	);
};
